import styled from "styled-components";

const ViagensDetail = styled.div`
  width: 100%;

  margin: 100px 0px 40px 0px;
  display: flex;
  justify-content: center;

  padding: 0px 20px;

  .content {
    width: 100%;
    max-width: 1200px;
  }

  .content-page {
    margin-top: 20px;

    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .classificar {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 550px) {
      flex-direction: column;

      align-items: flex-start;

      gap: 20px;
    }

    .title {
      font-size: 2rem;
      font-weight: 500;
    }

    .content-classificar {
      display: flex;
      align-items: center;
      gap: 20px;

      .select {
        width: 150px;
      }
    }
  }

  .list-viagens {
    display: grid;

    grid-template-columns: 1fr 1fr 1fr 1fr;

    row-gap: 30px;
    column-gap: 20px;

    margin-top: 50px;

    @media (max-width: 1000px) {
      grid-template-columns: 1fr 1fr 1fr;
    }

    @media (max-width: 800px) {
      grid-template-columns: 1fr 1fr;
    }

    @media (max-width: 550px) {
      grid-template-columns: 1fr;
    }
  }

  .item-list {
    flex-basis: 280px;

    @media (max-width: 1200px) {
      flex-basis: 300px;
    }
  }
`;

export default ViagensDetail;
